// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__1cCYH","rootSmall":"AddTileButton_rootSmall__uQT_I"};